import type { FieldError } from 'react-hook-form'
import type { Options, OptionsEntries, OptionsEntry } from '../types'

/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isFieldError = (e: any): e is FieldError => {
    const fe = e as FieldError
    return typeof fe.type === 'string'
}

export const parseFieldError = (fe: FieldError | Error | unknown): string | undefined => {
    if (!fe) {
        return undefined
    }

    if (fe instanceof Error) {
        return fe.message
    }

    if (isFieldError(fe)) {
        return fe.message ? `${fe.type.toUpperCase()}: ${fe.message}` : fe.type.toUpperCase()
    }

    return 'Unknown Error'
}

export const isOptionsEntriesLike = (input: unknown): input is OptionsEntries =>
    Array.isArray(input) && Array.isArray(input[0])

export const optionsToEntries = (opts: Options): OptionsEntries =>
    isOptionsEntriesLike(opts)
        ? opts
        : Array.isArray(opts)
        ? opts.map((opt) => [opt, opt] as OptionsEntry)
        : Object.entries(opts)

export default {}
